import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function Badges({
  submenuTitle, menuItemTitle, options, selections, handleSelection,
}) {
  return (
    <Fragment>
      <div className="subcontent-title">{submenuTitle}</div>
      <div className="badges">
        {
        options.map(({ value, label }) => {
          const exists = submenuTitle
            ? selections[menuItemTitle][submenuTitle].includes(label)
            : selections[menuItemTitle].includes(label);
          return (
            <span
              className={`badge ${exists ? 'active' : ''}`}
              key={value}
              role="link"
              tabIndex={0}
              onClick={() => {
                if (submenuTitle) handleSelection(menuItemTitle, label, submenuTitle);
              }}
            >
              {label}
            </span>
          );
        })
      }
      </div>
    </Fragment>
  );
}

Badges.propTypes = {
  submenuTitle: PropTypes.string,
  menuItemTitle: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  selections: PropTypes.shape({}).isRequired,
  handleSelection: PropTypes.func.isRequired,
};

Badges.defaultProps = {
  submenuTitle: null,
};

export default Badges;
